import { Device } from '../../types/device';
import { ApiError } from '../../types/common';

export const getPasswordStrength = (password: string): number => {
  let strength = 0;
  if (password.length >= 1) strength += 1;
  if (password.length >= 8) strength += 1;
  if (/[A-Z]/.test(password)) strength += 1;
  if (/[0-9]/.test(password)) strength += 1;
  if (/[\]!"#$%&'()*+,./:;<=>?@[\\^_`{|}~-]/.test(password)) strength += 1;
  return strength;
};

export const formatDate = (date: Date): string => {
  return date.toLocaleDateString();
};

export const formatNumber = (num: number): string => {
  return num.toLocaleString();
};

export const isEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') return value.trim().length === 0;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
};

export const delay = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const generateUniqueId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const handleApiError = (error: unknown): ApiError => {
  if (error instanceof Error) {
    return {
      message: error.message,
      code: 'ERROR',
      status: 500,
    };
  }
  return {
    message: 'An unknown error occurred',
    code: 'UNKNOWN_ERROR',
    status: 500,
  };
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return emailRegex.test(email);
};

export const getCurrentDevice = (devices: Device | {}[], imeiNumber?: string): Device => {
  if (!imeiNumber || !devices?.length) return {} as Device;

  return devices.find((device: Device) => device.IMEINumber === imeiNumber) || {};
};

export const getTitleAsCurrentNameSerialNumber = (
  devices: Device[],
  imeiNumber?: string
): string => {
  const { Real_Name, FCIUniqueSerialNumber } = getCurrentDevice(devices, imeiNumber);
  return `${Real_Name || ''} | ${FCIUniqueSerialNumber || ''}`;
};

export const isEmptyObject = (obj: Record<string, any>): boolean => {
  return Object.getOwnPropertyNames(obj).length === 0;
};

export interface ErrorResponse {
  message?: string;
}

// Re-export command utilities from centralized config
export { getReadableCommand, getReadableCommandFromString } from '../../config/commands';
